import Cookies from "js-cookie";

(() => {
    window.addEventListener("DOMContentLoaded", () => {
        let params = new URLSearchParams(window.location.search)

        for (let name of ["gclid", "msclkid", "utm_source", "utm_medium", "utm_campaign", "utm_content"]) {
            if (params.get(name)) {
                Cookies.set(name, params.get(name))
            }
        }

        if (Cookies.get("gclid") && document.querySelectorAll("input.gclidinput").length) {
            document.querySelectorAll("input.gclidinput").forEach((input) => {
                input.value = Cookies.get("gclid")
            })
        }

        if (Cookies.get("msclkid") && document.querySelectorAll("input.msclidinput").length) {
            document.querySelectorAll("input.msclidinput").forEach((input) => {
                input.value = Cookies.get("msclkid")
            })
        }

        if (Cookies.get("utm_source") && document.querySelectorAll("input.utmsourceinput").length) {
            document.querySelectorAll("input.utmsourceinput").forEach((input) => {
                input.value = Cookies.get("utm_source")
            })
        }

        if (Cookies.get("utm_campaign") && document.querySelectorAll("input.utmcampaigninput").length) {
            document.querySelectorAll("input.utmcampaigninput").forEach((input) => {
                input.value = Cookies.get("utm_campaign")
            })
        }

        if (Cookies.get("utm_content") && document.querySelectorAll("input.utmcontentinput").length) {
            document.querySelectorAll("input.utmcontentinput").forEach((input) => {
                input.value = Cookies.get("utm_content")
            })
        }

        if (Cookies.get("utm_medium") && document.querySelectorAll("input.utmmediuminput").length) {
            document.querySelectorAll("input.utmmediuminput").forEach((input) => {
                input.value = Cookies.get("utm_medium")
            })
        }
    })
}) ()

